import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.feature.id + "-" + _vm.item.resource.id,
      staticClass: "feature-popup-container",
    },
    [
      _c(
        VTabs,
        {
          attrs: { centered: "", dark: "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(VTab, { attrs: { href: "#tab-1" } }, [_vm._v(" Attributes ")]),
          _vm._v(" "),
          _vm.attachments.length
            ? _c(VTab, { attrs: { href: "#tab-2" } }, [
                _vm._v(" Attachments "),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VTabsItems,
        {
          attrs: { dark: "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            VTabItem,
            { attrs: { value: "tab-1" } },
            [
              _c(VSimpleTable, {
                staticClass: "popup-container-table",
                attrs: { dense: "", dark: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function () {
                      return [
                        _c(
                          "tbody",
                          _vm._l(_vm.fields, function (f) {
                            return _c("tr", { key: f.keyname }, [
                              _c("td", [_vm._v(_vm._s(f.display_name))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.getValue(f.keyname))),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(VTabItem, { attrs: { value: "tab-2" } }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column justify-space-between align-center",
              },
              _vm._l(_vm.attachments, function (a) {
                return _c("div", { key: a.id }, [
                  a.is_image
                    ? _c("div", [
                        a.description
                          ? _c("div", { staticClass: "subheading" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(a.description) +
                                  "\n            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openAttachment(a)
                              },
                            },
                          },
                          [
                            _c(VImg, {
                              staticClass: "ma-2",
                              attrs: {
                                "max-height": _vm.imagePreviewHeight,
                                "max-width": _vm.imagePreviewWidth,
                                src: a.imageUrl,
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ])
              }),
              0
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.activeAttachment || _vm.loadingActiveAttachment
        ? _c(
            VRow,
            { attrs: { justify: "center" } },
            [
              _c(
                VDialog,
                {
                  attrs: {
                    value: _vm.loadingActiveAttachment,
                    dark: "",
                    "hide-overlay": "",
                    persistent: "",
                    width: "300",
                  },
                },
                [
                  _c(
                    VCard,
                    { attrs: { dark: "" } },
                    [
                      _c(
                        VCardText,
                        [
                          _vm._v(
                            "\n          Loading attachment...\n          "
                          ),
                          _c(VProgressLinear, {
                            staticClass: "mb-0",
                            attrs: { indeterminate: "", color: "white" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.activeAttachment
                ? _c(
                    VDialog,
                    {
                      attrs: {
                        value: !!_vm.activeAttachment,
                        dark: "",
                        scrollable: "",
                      },
                    },
                    [
                      _c(
                        VCard,
                        { attrs: { dark: "" } },
                        [
                          _c(
                            VCardTitle,
                            [
                              _vm.activeAttachment.description
                                ? _c("span", { staticClass: "text-h5" }, [
                                    _vm._v(
                                      _vm._s(_vm.activeAttachment.description)
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(VSpacer),
                              _vm._v(" "),
                              _c(
                                VBtn,
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.activeAttachment = false
                                    },
                                  },
                                },
                                [
                                  _c(VIcon, [
                                    _vm._v(_vm._s(_vm.icon.close)),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(VDivider),
                          _vm._v(" "),
                          _c(
                            VCardText,
                            [
                              _c(VImg, {
                                staticClass: "ma-2",
                                attrs: { src: _vm.activeAttachment.imageUrl },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }